import { CameraSource } from 'lib_ts/enums/machine-msg.enum';
import { IOption } from 'lib_ts/interfaces/common/i-option';

export enum BlinkerMode {
  Disconnected,
  Paused,
  Live,
}

export const CAMERA_OPTIONS: IOption[] = [
  {
    label: 'BI_RIGHT',
    value: CameraSource.BI_RIGHT,
  },
  {
    label: 'BI_R',
    value: CameraSource.BI_R,
  },
  {
    label: 'STEREO_CHECK',
    value: CameraSource.STEREO_CHECK,
  },
  {
    label: 'SPIN_DETECTOR',
    value: CameraSource.SPIN_DETECTOR,
  },
  {
    label: 'BI_DEBUG',
    value: CameraSource.BI_DEBUG,
  },
];
